module.exports = __webpack_public_path__ + "static/media/POSTRAK_2023.801c0406.pdf";